import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuDataElementComponent } from '@shared/ui-components/au-view-entity/view-entity-component/au-data-elemt/au-data-element.component';
import { ViewEntityComponent } from '@shared/ui-components/au-view-entity/view-entity-component/view-entity.component';

// Do not change direct path as it will resolve into circular dependency
import { AuRoundAvatarModule } from '@shared/ui-components/au-round-avatar/au-round-avatar.module';

@NgModule({
	imports: [
		CommonModule,
		AuRoundAvatarModule,
		ViewEntityComponent,
		AuDataElementComponent,
	],
	exports: [ViewEntityComponent],
})
export class AuViewEntityModule {}
